/** @jsxImportSource @emotion/react */
import React from 'react'

import * as styles from './styles'

export default function Emoji30() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 45 45" css={styles.svg}>
      <g transform="matrix(1,0,0,1,-396.281,-3486.36)">
        <g transform="matrix(0.683279,0,0,0.683279,373.769,3232.44)">
          <g transform="matrix(0.937093,0,0,0.937093,-93.4482,11.5477)">
            <g opacity="0.75">
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M184.89,429.86c-0.85,0 -1.23,-0.35 -2.18,-1.44c-1.218,-1.846 -3.288,-2.96 -5.5,-2.96c-2.212,0 -4.282,1.114 -5.5,2.96c-0.95,1.09 -1.33,1.44 -2.19,1.44c-0.86,0 -1.23,-0.35 -2.19,-1.44c-1.222,-1.842 -3.29,-2.952 -5.5,-2.952c-2.21,0 -4.278,1.11 -5.5,2.952c-1,1.09 -1.34,1.44 -2.19,1.44c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2c2.193,-0.066 4.232,-1.16 5.5,-2.95c1,-1.09 1.34,-1.45 2.19,-1.45c0.85,0 1.24,0.36 2.2,1.45c1.218,1.846 3.288,2.96 5.5,2.96c2.212,0 4.282,-1.114 5.5,-2.96c0.95,-1.09 1.33,-1.45 2.19,-1.45c0.86,0 1.23,0.36 2.18,1.45c1.266,1.787 3.301,2.881 5.49,2.95c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M154.15,414.49l8.78,0c0.049,0.003 0.099,0.005 0.148,0.005c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2c-0.049,0 -0.099,0.002 -0.148,0.005l-8.78,0c-0.049,-0.003 -0.099,-0.005 -0.148,-0.005c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2c0.049,0 0.099,-0.002 0.148,-0.005"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M184.89,410.1l-8.78,0c-0.049,-0.003 -0.099,-0.005 -0.148,-0.005c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2c0.049,0 0.099,-0.002 0.148,-0.005l8.78,0c0.049,0.003 0.099,0.005 0.148,0.005c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2c-0.049,0 -0.099,0.002 -0.148,0.005"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M169.52,383.75c-19.277,0 -35.14,15.863 -35.14,35.14c0,19.277 15.863,35.14 35.14,35.14c19.277,0 35.14,-15.863 35.14,-35.14c0,-0.003 0,-0.007 0,-0.01c-0.027,-19.265 -15.875,-35.108 -35.14,-35.13m0,65.88c-16.869,0 -30.75,-13.881 -30.75,-30.75c0,-16.869 13.881,-30.75 30.75,-30.75c16.869,0 30.75,13.881 30.75,30.75c-0.022,16.861 -13.889,30.728 -30.75,30.75"
                  css={styles.svg}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
